interface BaxterIconProps {
  width?: string | number;
  height?: string | number;
  className?: string;
  fillColor?: string;
}

const BaxterIcon: React.FC<BaxterIconProps> = ({
  width = 32,
  height = 32,
  className,
  fillColor = "#252969",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Bitcoin Icon"
    >
      <rect width="32" height="32" rx="4" fill={fillColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.2327 6.98193L9.21652 7.04976L9.24346 8.29785L5.13159 22.8014L4 24.8726L21.1163 24.8627C22.6648 24.8975 23.9911 24.4139 24.6965 23.189C25.2102 21.3895 26.1331 19.697 25.9247 17.6916C25.6749 16.9115 25.0853 16.1921 24.3497 15.7195C25.0747 15.5177 25.7971 15.2567 26.3658 14.7066C27.5801 13.1721 27.9513 11.2416 28 9.34598C27.7252 8.18593 26.4878 7.1809 25.2327 6.98193ZM16.5639 9.94346L20.7636 9.97822C21.3472 10.2965 21.1358 11.1113 21.0003 11.5445C20.6322 12.4203 20.6576 13.5848 19.7973 14.1669L14.9812 14.1878L16.5639 9.94346ZM14.1356 17.1273L18.5986 17.1091C19.2166 17.3708 19.0602 18.2115 18.892 18.6768C18.3265 19.6898 18.977 21.2492 17.7712 21.8133L12.9145 21.8066C13.1218 20.2571 13.7302 18.6795 14.1356 17.1273Z"
        fill="white"
      />
    </svg>
  );
};

export default BaxterIcon;
